import React, { useEffect, useRef, useState } from "react";
import "./table.scss"; // فقط این خط برای استایل
import { showCatchError, toEnglishNumbers } from "../../helpers/Utils";
import Excel from "./excel";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import FormControl from "@mui/material/FormControl";
import axios from "../../containers/api";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Button,
  Label,
  Input,
  FormGroup,
} from "reactstrap";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const Table = ({
  tableHeaders,
  tableRow,
  tableData,
  tableFieldsProp,
  showAlert,
  showSpinner,
  hideSpinner,
  closeSweetAlert,
  showSweetAlert,
  reportType,
}) => {
  const [tableSearchValue, setTableSearchValue] = useState("");
  const [tableRowCount, setTableRowCount] = useState(10);
  const [pageNumbers, setPageNumbers] = useState([]);
  const [selectedPage, setSelectedPage] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(10);
  const [searchedTableRow, setSearchedTableRow] = useState([]);
  const myTableBody = useRef(null);
  const myTable = useRef();
  const [tableColumns, setTableColumns] = useState(tableHeaders);
  const [tableColumnsIndex, setTableColumnsIndex] = useState([]);
  const [memberReports, setMemberReports] = useState([]);
  const [memberReport, setMemberReport] = useState(null);
  const [createReport, setCreateReport] = useState(false);
  const [reportName, setReportName] = useState(null);
  const [reportCols, setReportCols] = useState([]);
  const [reportColsName, setReportColsName] = useState([]);

  // جستجو و صفحه‌بندی
  useEffect(() => {
    const filtered = tableRow.filter((item) =>
      JSON.stringify(item).includes(tableSearchValue)
    );
    setSearchedTableRow(filtered);

    const pages = Math.ceil(filtered.length / tableRowCount);
    const arr = Array.from({ length: pages }, (_, i) => i);
    setPageNumbers(arr);

    const start = tableRowCount === 1000000 ? 0 : tableRowCount * selectedPage;
    const end =
      tableRowCount === 1000000
        ? filtered.length
        : Math.min(tableRowCount * (selectedPage + 1), filtered.length);
    setFrom(start);
    setTo(end);
  }, [tableRow, tableRowCount, selectedPage, tableSearchValue]);

  // دریافت گزارش‌های کاربر
  useEffect(() => {
    if (tableFieldsProp) getMemberReports();
  }, [tableFieldsProp]);

  // مرتب‌سازی جدول
  const sortTable = (n) => {
    const table = myTableBody.current;
    if (!table) return;

    let switching = true,
      dir = "asc",
      switchCount = 0;
    while (switching) {
      switching = false;
      const rows = table.rows;
      for (let i = 0; i < rows.length - 1; i++) {
        let shouldSwitch = false;
        const x = rows[i].cells[n],
          y = rows[i + 1].cells[n];
        const xVal = toEnglishNumbers(x.innerHTML),
          yVal = toEnglishNumbers(y.innerHTML);

        if (dir === "asc") {
          if (/\d/.test(xVal)) {
            if (parseInt(xVal.split("/").pop()) > parseInt(yVal.split("/").pop()))
              shouldSwitch = true;
          } else if (xVal.toLowerCase() > yVal.toLowerCase()) shouldSwitch = true;
        } else {
          if (/\d/.test(xVal)) {
            if (parseInt(xVal.split("/").pop()) < parseInt(yVal.split("/").pop()))
              shouldSwitch = true;
          } else if (xVal.toLowerCase() < yVal.toLowerCase()) shouldSwitch = true;
        }

        if (shouldSwitch) {
          rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
          switching = true;
          switchCount++;
        }
      }
      if (!switchCount && dir === "asc") {
        dir = "desc";
        switching = true;
      }
    }
  };

  // تغییر ستون‌های نمایش
  const handleChange = (e) => {
    const { value } = e.target;
    setTableColumns(typeof value === "string" ? value.split(",") : value);
  };

  const getMemberReports = (created = false) => {
    axios
      .get(`api/reportApi/GetReportBymemberId?ReportType=${reportType}`)
      .then((res) => {
        setMemberReports(res.data === "موردی یافت نشد" ? [] : res.data);
        if (created) closeCreateReport();
      })
      .catch((err) => showAlert(showCatchError(err), "error"));
  };

  const handleNewReportColsChange = (e) => {
    const { value } = e.target;
    setReportColsName(typeof value === "string" ? value.split(",") : value);
  };

  const handleAddReportCols = (index) => {
    const newCol = tableFieldsProp[index];
    setReportCols((prev) =>
      prev.includes(newCol)
        ? prev.filter((col) => col !== newCol)
        : [...prev, newCol]
    );
  };

  const createNewReport = () => {
    if (!reportName?.trim())
      return showAlert("لطفا نام گزارش را وارد کنید.", "error");

    const fields = reportCols.map((col) => ({
      LatinName: col.field,
      FarsiName: col.title,
    }));

    const postData = {
      Name: toEnglishNumbers(reportName),
      ReportName: reportType,
      ReportId: null,
      ColumnList: fields,
    };

    showSpinner();
    axios
      .post("api/reportApi/SaveReport", postData)
      .then(() => {
        hideSpinner();
        showAlert("گزارش جدید با موفقیت اضافه شد", "success");
        getMemberReports(true);
      })
      .catch((err) => {
        hideSpinner();
        showAlert(showCatchError(err), "error");
      });
  };

  const handleSelectMemberReport = (e, report) => {
    if (!report) return;
    setMemberReport(report);
    const cols = report.farsiColumnName;
    const hidden = tableHeaders.reduce(
      (acc, h, i) => (cols.includes(h) ? acc : [...acc, i]),
      []
    );
    setTableColumnsIndex(hidden);
    setTableColumns(cols);
  };

  const closeCreateReport = () => {
    setReportName(null);
    setReportCols([]);
    setCreateReport(false);
  };

  const handleIndexChangeColumns = (index) => {
    setTableColumnsIndex((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index)
        : [...prev, index]
    );
  };

  const renderPages = () => {
    const buttons = [];
    const total = pageNumbers.length;
    if (total <= 5) {
      pageNumbers.forEach((_, i) =>
        buttons.push(
          <PaginationItem key={i} active={selectedPage === i}>
            <PaginationLink onClick={() => changePage(i)}>{i + 1}</PaginationLink>
          </PaginationItem>
        )
      );
    } else {
      const start = selectedPage > 2 ? Math.max(selectedPage - 2, 0) : 0;
      const end = Math.min(start + 5, total);
      for (let i = start; i < end; i++) {
        buttons.push(
          <PaginationItem key={i} active={selectedPage === i}>
            <PaginationLink onClick={() => changePage(i)}>{i + 1}</PaginationLink>
          </PaginationItem>
        );
      }
    }
    return buttons;
  };

  const changePage = (i) => {
    if (i === "prev" && selectedPage > 0) setSelectedPage(selectedPage - 1);
    else if (i === "next" && selectedPage < pageNumbers.length - 1)
      setSelectedPage(selectedPage + 1);
    else if (i === "first") setSelectedPage(0);
    else if (i === "last") setSelectedPage(pageNumbers.length - 1);
    else setSelectedPage(i);
  };

  const changePageSize = (size) => {
    setTableRowCount(size);
    setSelectedPage(0);
  };

  const deleteReport = (id) => {
    closeSweetAlert();
    axios
      .post(`api/reportApi/DeleteReport?reportid=${id}`)
      .then(() => {
        showAlert("گزارش مورد نظر با موفقیت حذف گردید", "success");
        getMemberReports();
      })
      .catch(() => showAlert("خطا در حذف گزارش", "error"));
  };

  return (
    <div className="table-wrapper">
      {/* هدر جدول */}
      <div className="table-header">
        <div className="table-options">
          {createReport ? (
            <>
              <FormGroup className="reportName">
                <Label>نام گزارش</Label>
                <Input
                  value={reportName || ""}
                  onChange={(e) => setReportName(e.target.value)}
                />
              </FormGroup>

              <div className="table-options-rows">
                <FormControl size="small" sx={{ m: 1, width: 300 }}>
                  <label className="form-title">انتخاب ستون‌های گزارش</label>
                  <Select
                    multiple
                    value={reportColsName}
                    onChange={handleNewReportColsChange}
                    input={<OutlinedInput label="انتخاب ستون‌های گزارش" />}
                    renderValue={(selected) => selected.join(", ")}
                    MenuProps={MenuProps}
                  >
                    {tableFieldsProp?.map((field, index) => (
                      <MenuItem
                        key={field.field}
                        value={field.title}
                        onClick={() => handleAddReportCols(index)}
                      >
                        <Checkbox
                          checked={reportCols.some((col) => col.field === field.field)}
                        />
                        <ListItemText primary={field.title} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </>
          ) : (
            <>
              <div className="table-options-rows" />

              {memberReports.length > 0 && (
                <FormGroup>
                  <Label>گزارش‌های اختصاصی کاربر</Label>
                  <Autocomplete
                    options={memberReports}
                    getOptionLabel={(opt) => opt.farsiReportName}
                    value={memberReport}
                    onChange={handleSelectMemberReport}
                    renderInput={(params) => (
                      <TextField {...params} variant="standard" />
                    )}
                    renderOption={(props, option) => (
                      <li {...props}>
                        <span className="d-flex justify-content-between w-100 align-items-center">
                          {option.farsiReportName}
                          <Button
                            outline
                            color="danger"
                            size="sm"
                            onClick={(e) => {
                              e.stopPropagation();
                              showSweetAlert(
                                "آیا از حذف این گزارش مطمئن هستید؟",
                                "",
                                "danger",
                                () => deleteReport(option.id)
                              );
                            }}
                          >
                            <i className="fa fa-trash" />
                          </Button>
                        </span>
                      </li>
                    )}
                  />
                </FormGroup>
              )}
            </>
          )}

          {tableFieldsProp ? (
            <div className="table-options-rows">
              {createReport ? (
                <>
                  <Button color="success" onClick={createNewReport}>
                    تایید
                  </Button>
                  <Button color="danger" onClick={closeCreateReport}>
                    انصراف
                  </Button>
                </>
              ) : (
                <Button color="primary" outline onClick={() => setCreateReport(true)}>
                  ایجاد گزارش جدید
                </Button>
              )}
            </div>
          ) : (
            <div className="table-options-rows" />
          )}
        </div>

        {/* ابزارها */}
        <div className="row">
          <div className="col-md-4 col-12 d-flex justify-content-center align-items-center">
            {myTable.current && (
              <Excel
                className="excel-btn btn btn-outline-primary btn-sm"
                table={myTable.current}
                filename="گزارش"
                sheet="گزارش"
                buttonText="خروجی اکسل"
              />
            )}
          </div>

          <div className="col-md-4 col-12 d-flex justify-content-center align-items-end" />

          <div className="col-md-4 col-12 d-flex justify-content-center align-items-center">
            <FormControl size="small" sx={{ m: 1, width: 300 }}>
              <label className="form-title">انتخاب ستون‌های جدول</label>
              <Select
                multiple
                value={tableColumns}
                onChange={handleChange}
                input={<OutlinedInput label="انتخاب ستون‌های جدول" />}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
              >
                {tableHeaders.map((header, index) => (
                  <MenuItem
                    key={header}
                    value={header}
                    onClick={() => handleIndexChangeColumns(index)}
                  >
                    <Checkbox checked={tableColumns.includes(header)} />
                    <ListItemText primary={header} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>

        {/* جستجو و صفحه‌بندی */}
        <div className="row mt-3">
          <div className="col-md-4 col-12 d-flex justify-content-center align-items-center order-0">
            <div className="search-sm d-inline-block mr-1 mb-1">
              <input
                type="text"
                placeholder="جستجو در جدول"
                onKeyPress={(e) =>
                  setTableSearchValue(toEnglishNumbers(e.target.value))
                }
                autoComplete="off"
              />
            </div>
          </div>

          <div className="col-md-4 col-12 d-flex flex-column justify-content-center align-items-center order-md-1 order-2">
            <span>
              نمایش {from === 0 ? 1 : from + 1} تا{" "}
              {to > searchedTableRow.length ? searchedTableRow.length : to} از{" "}
              {searchedTableRow.length}
            </span>

            {tableRowCount !== 1000000 ? (
              <Pagination size="sm" className="mt-2">
                <PaginationItem disabled={selectedPage === 0}>
                  <PaginationLink onClick={() => changePage("first")}>
                    اولین
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem disabled={selectedPage === 0}>
                  <PaginationLink onClick={() => changePage("prev")}>
                    <i className="simple-icon-arrow-left" />
                  </PaginationLink>
                </PaginationItem>
                {renderPages()}
                <PaginationItem
                  disabled={selectedPage === pageNumbers.length - 1}
                >
                  <PaginationLink onClick={() => changePage("next")}>
                    <i className="simple-icon-arrow-right" />
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem
                  disabled={selectedPage === pageNumbers.length - 1}
                >
                  <PaginationLink onClick={() => changePage("last")}>
                    آخرین
                  </PaginationLink>
                </PaginationItem>
              </Pagination>
            ) : (
              <Pagination size="sm">
                <PaginationItem active>
                  <PaginationLink>1</PaginationLink>
                </PaginationItem>
              </Pagination>
            )}
          </div>

          <div className="col-md-4 col-12 d-flex justify-content-center align-items-center order-md-2 order-1 my-2">
            <span className="mr-1">تعداد سطر:</span>
            <UncontrolledDropdown>
              <DropdownToggle caret color="outline-dark" size="xs">
                {tableRowCount === 1000000 ? "همه" : tableRowCount}
              </DropdownToggle>
              <DropdownMenu right>
                {[5, 10, 25, 50, 100, 1000000].map((size) => (
                  <DropdownItem
                    key={size}
                    onClick={() => changePageSize(size)}
                  >
                    {size === 1000000 ? "همه" : size}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </div>
      </div>

      {/* جدول اصلی */}
      <div className="table-container">
        <table ref={myTable}>
          <thead>
            <tr>
              <th onClick={() => sortTable(0)}>
                <i className="fa fa-sort mr-1" />
                ردیف
              </th>
              {tableHeaders.map((header, i) =>
                tableColumns.includes(header) ? (
                  <th key={i + 1} onClick={() => sortTable(i + 1)}>
                    <i className="fa fa-sort mr-1" />
                    {header}
                  </th>
                ) : null
              )}
            </tr>
          </thead>
          <tbody ref={myTableBody}>
            {searchedTableRow.slice(from, to).map((item, i) => (
              <tr key={i}>
                <td>{from + i + 1}</td>
                {tableData.map(
                  (renderFn, j) =>
                    !tableColumnsIndex.includes(j) && (
                      <td key={j + 1}>{renderFn(item)}</td>
                    )
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};